<script lang="ts">
import { defineComponent, inject, ref } from 'vue';
import { useRouter } from 'vue-router';

import AuthServiceInterface from '@/services/interfaces/AuthServiceInterface';
import cleanLocalStorage from '@/utils/localStorage';

export default defineComponent({
  name: 'ModalLogout',
  setup() {
    const authService = inject<AuthServiceInterface>('authService');
    const router = useRouter();

    const isOpen = ref(false);

    const closeModal = () => {
      isOpen.value = false;
    };

    const openModal = () => {
      isOpen.value = true;
    };

    const logout = () => {
      authService?.logout().then(() => {
        closeModal();
        cleanLocalStorage();
        router.push({ name: 'login' });
      });
    };

    return { isOpen, openModal, closeModal, logout };
  },
});
</script>

<template>
  <div v-if="isOpen" class="modal-overlay z-30" @click.self="closeModal">
    <div class="modal-content">
      <h1 class="text-lg font-bold text-center text-blue-600 pb-4">
        Deseja realmente sair da Aplicação?
      </h1>
      <div class="flex gap-4">
        <button
          class="bg-transparent hover:bg-blue-400 text-blue-700 font-semibold hover:text-white py-2 px-4 w-full text-sm border border-blue-500 hover:border-transparent rounded-xl"
          @click="closeModal"
        >
          Cancelar
        </button>
        <button
          class="btn-primary bg-blue-500 hover:bg-blue-700 border text-white font-semibold text-sm py-2 px-4 rounded-xl w-full"
          @click="logout"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.modal-content {
  background-color: white;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 24px;
  border-radius: 10px;
  width: 100%;

  @media (min-width: 1200px) {
    width: calc(450px - 2rem);
  }
}
</style>
